var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4286 14.7143H17V9.28571C17 9.12857 16.8714 9 16.7143 9H15C14.8429 9 14.7143 9.12857 14.7143 9.28571V14.7143H9.28571C9.12857 14.7143 9 14.8429 9 15V16.7143C9 16.8714 9.12857 17 9.28571 17H14.7143V22.4286C14.7143 22.5857 14.8429 22.7143 15 22.7143H16.7143C16.8714 22.7143 17 22.5857 17 22.4286V17H22.4286C22.5857 17 22.7143 16.8714 22.7143 16.7143V15C22.7143 14.8429 22.5857 14.7143 22.4286 14.7143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16429 0 0 7.16429 0 16C0 24.8357 7.16429 32 16 32C24.8357 32 32 24.8357 32 16C32 7.16429 24.8357 0 16 0ZM16 29.2857C8.66429 29.2857 2.71429 23.3357 2.71429 16C2.71429 8.66429 8.66429 2.71429 16 2.71429C23.3357 2.71429 29.2857 8.66429 29.2857 16C29.2857 23.3357 23.3357 29.2857 16 29.2857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9cf4972842b619e96f1ee4bfcd1fce2e.svg";
export { ForwardRef as ReactComponent };